import { api } from './api';

export type CommitteeRole = 'chair' | 'secretary' | 'member';

export const COMMITTEE_ROLE_LABEL: Record<CommitteeRole, string> = {
  chair: 'Chair',
  secretary: 'Secretary',
  member: 'Member',
};

export interface CommitteeListItem {
  id: string;
  name: string;
  remit: string | null;
  quorum: number | null;
  isActive: boolean;
  memberCount: number;
  chair: { firstName: string; lastName: string } | null;
}

export interface CommitteeMemberRow {
  userId: string;
  role: CommitteeRole;
  appointedAt: string;
  user: { id: string; firstName: string; lastName: string; email: string; memberType: string };
}

export interface CommitteeDetail {
  id: string;
  name: string;
  remit: string | null;
  quorum: number | null;
  isActive: boolean;
  members: CommitteeMemberRow[];
}

export async function fetchCommittees(): Promise<CommitteeListItem[]> {
  return (await api.get('/committees')).data.data as CommitteeListItem[];
}
export async function fetchCommittee(id: string): Promise<CommitteeDetail> {
  return (await api.get(`/committees/${id}`)).data.data as CommitteeDetail;
}
export async function createCommittee(input: { name: string; remit?: string; quorum?: number }): Promise<{ id: string; name: string }> {
  return (await api.post('/committees', input)).data.data;
}
export async function updateCommittee(
  id: string,
  input: { name?: string; remit?: string | null; quorum?: number | null; isActive?: boolean },
): Promise<void> {
  await api.patch(`/committees/${id}`, input);
}
export async function deleteCommittee(id: string): Promise<void> {
  await api.delete(`/committees/${id}`);
}
export async function setCommitteeMember(id: string, userId: string, role: CommitteeRole): Promise<void> {
  await api.post(`/committees/${id}/members`, { userId, role });
}
export async function removeCommitteeMember(id: string, userId: string): Promise<void> {
  await api.delete(`/committees/${id}/members/${userId}`);
}
